import React, { useEffect, useState } from 'react';
import { Box, Button, CircularProgress, Typography } from '@mui/material';
import { useFormPalette } from '../DynamicFormPrimitives';

/**
 * Shown while the engine is between steps (FlowSession.status = TRANSITIONING). Starts with a
 * neutral spinner; after 4s swaps to a reassurance line; on {@code sseError} surfaces a retry
 * button that re-subscribes and re-fetches via {@code onRetry}.
 */
export default function FormFlowTransitionScreen({
  accent,
  sseError = false,
  onRetry,
}) {
  const palette = useFormPalette();
  const [waited, setWaited] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setWaited(true), 4000);
    return () => clearTimeout(t);
  }, []);

  return (
    <Box sx={{
      minHeight: '100vh', bgcolor: palette.bg,
      display: 'flex', alignItems: 'center', justifyContent: 'center', px: 3,
    }}>
      <Box sx={{
        maxWidth: 520, width: '100%', textAlign: 'center',
        bgcolor: palette.surface, border: `1px solid ${palette.border}`,
        borderRadius: '12px', p: 4,
      }}>
        {sseError ? (
          <>
            <Typography variant="h6" sx={{ mb: 1 }}>We lost the connection to the workflow.</Typography>
            <Typography sx={{ color: palette.textSecondary, mb: 2.5 }}>
              Your progress is saved. Tap retry to pick up where it left off.
            </Typography>
            {onRetry && (
              <Button variant="contained" onClick={onRetry} sx={{ backgroundColor: accent, textTransform: 'none' }}>
                Retry
              </Button>
            )}
          </>
        ) : (
          <>
            <CircularProgress size={32} sx={{ color: accent, mb: 2 }} />
            <Typography variant="h6" sx={{ mb: 0.5 }}>Working on your next step…</Typography>
            <Typography sx={{ color: palette.textSecondary }}>
              {waited ? 'Still working, hang tight — this should only take a moment.' : ' '}
            </Typography>
          </>
        )}
      </Box>
    </Box>
  );
}
